import { useEffect } from 'react';

export const useScrollToTopOnError = (errorMessage: string): void => {
  useEffect(() => {
    if (errorMessage !== '') {
      window.scrollTo(0, 0);
    }
  }, [errorMessage]);
};
